<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="mb-3 transition-all duration-300">
    <div
      class="inline-flex items-center gap-4 min-w-[20rem] max-w-[28rem] px-5 py-3.5 bg-background/80 backdrop-blur-xl border border-border shadow-2xl rounded-2xl text-left rtl:text-right ring-1 ring-black/5"
    >
      <div
        class="flex-shrink-0 size-8 rounded-full bg-primary/10 flex items-center justify-center"
      >
        <span class="i-lucide-bell size-4 text-primary" />
      </div>

      <div class="flex-grow min-w-0">
        <p class="text-sm font-semibold text-foreground leading-tight truncate">
          {{ message }}
        </p>
      </div>

      <div v-if="action" class="flex-shrink-0">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="text-xs font-bold uppercase tracking-widest text-primary hover:text-primary/80 transition-colors"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
